import React, { useState } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

const DateSelect = ({handleDate, startDate}) => {
  
  return (
    <DatePicker selected={startDate} onChange={(date) => handleDate(date)} className="form-control" />
  );
};

export default DateSelect;